export default function IconDisable() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15 7.08333H14.1667V5.41667C14.1667 3.11667 12.3 1.25 10 1.25C7.70004 1.25 5.83337 3.11667 5.83337 5.41667H7.50004C7.50004 4.03333 8.61671 2.91667 10 2.91667C11.3834 2.91667 12.5 4.03333 12.5 5.41667V7.08333H5.00004C4.08337 7.08333 3.33337 7.83333 3.33337 8.75V17.0833C3.33337 18 4.08337 18.75 5.00004 18.75H15C15.9167 18.75 16.6667 18 16.6667 17.0833V8.75C16.6667 7.83333 15.9167 7.08333 15 7.08333ZM15 17.0833H5.00004V8.75H15V17.0833ZM10 14.5833C10.9167 14.5833 11.6667 13.8333 11.6667 12.9167C11.6667 12 10.9167 11.25 10 11.25C9.08337 11.25 8.33337 12 8.33337 12.9167C8.33337 13.8333 9.08337 14.5833 10 14.5833Z'
        fill='#121212'
      />
    </svg>
  )
}
